export default "__VITE_ASSET__BNXaOfU3__"